import React, { useState, useEffect } from "react";
import FilterChip from "../../components/Chip/FilterChip";
import SearchBar from "../../components/Search/SearchBar";
import PayoutTable from "../../components/Table/PayoutTable";
import axios from "axios";
import { open_api_with_cookies } from "../../Utils/network";
import "./Payout.css";
import LoadingOverlay from "../../components/Loading/LoadingOverlay";

const Payout = () => {
  const [payoutData, setPayoutData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");

  // Generate filter options dynamically based on current date
  const generateFilterOptions = () => {
    const options = [];
    const mapping = {};
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get current date
    const currentDate = new Date();

    // Generate options for the last 6 months
    for (let i = 0; i < 6; i++) {
      const date = new Date(currentDate);
      date.setMonth(currentDate.getMonth() - i);

      const month = date.getMonth() + 1; // JS months are 0-indexed
      const year = date.getFullYear();
      const label = `${months[month - 1]} ${year}`;

      options.push(label);
      mapping[label] = { month, year };
    }

    return { options, mapping };
  };

  const { options: filterOptions, mapping: filterMapping } =
    generateFilterOptions();

  // Set initial selected date and filter
  useEffect(() => {
    if (filterOptions.length > 0 && !selectedFilter) {
      const initialFilter = filterOptions[0];
      setSelectedFilter(initialFilter);
      setSelectedDate(filterMapping[initialFilter]);
    }
  }, [filterOptions]);

  useEffect(() => {
    if (selectedDate) {
      fetchPayoutData();
    }
  }, [selectedDate, currentPage, searchQuery]);

  const fetchPayoutData = async () => {
    setIsLoading(true);
    try {
      const response = await open_api_with_cookies.get(
        `/dashboard/payout/list/?month=${selectedDate.month}&year=${
          selectedDate.year
        }&page=${currentPage}${searchQuery ? `&q=${searchQuery}` : ""}`
      );
      setPayoutData(response.data.data);
      setTotalCount(response.data.total_count);
    } catch (error) {
      console.error("Error fetching payout data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterSelect = (option) => {
    setSelectedFilter(option);
    setSelectedDate(filterMapping[option]);
    setCurrentPage(1);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="payout-container">
      <div className="payout-header">
        <h1>Hello Vivin 👋</h1>
      </div>

      <div className="payout-filter-row">
        <div className="filter-section">
          <FilterChip
            options={filterOptions}
            selected={selectedFilter}
            onSelect={handleFilterSelect}
          />
        </div>
        <div className="search-section">
          <SearchBar onSearch={handleSearch} />
        </div>
      </div>

      {isLoading ? (
        <LoadingOverlay />
      ) : payoutData.length > 0 ? (
        <PayoutTable
          data={payoutData}
          totalItems={totalCount}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      ) : (
        <div className="no-data">No data found</div>
      )}
    </div>
  );
};

export default Payout;
